export const materialTypes = {
	BRONZE: 'BRONZE',
	IRON: 'IRON',
	STEEL: 'STEEL',
	MITHRIL: 'MITHRIL',
	ADAMANTIUM: 'ADAMANTIUM',
	ORICHALCUM: 'ORICHALCUM',
	VULCANITE: 'VULCANITE',
	AQUANITE: 'AQUANITE',
	VRONITE: 'VRONITE',
	LOULOUDIUM: 'LOULOUDIUM',
	ILIOTIUM: 'ILIOTIUM',
	LEVANTIUM: 'LEVANTIUM'
}



// WEBPACK FOOTER //
// ./src/assets/js/game/utils/Constants.js